/**
 * Utilitários para manipulação e formatação de endereços
 */

/**
 * Formata um objeto de endereço em um texto legível
 * @param {Object} addressData - Objeto com os dados do endereço
 * @returns {string} - Endereço formatado como texto
 */
export const formatFullAddress = (addressData) => {
  // Verificar se o endereço é válido
  if (!addressData || typeof addressData !== 'object') {
    return '';
  }
  
  try {
    // Extrair campos do endereço com verificação de existência
    const street = addressData.street ? String(addressData.street).trim() : '';
    const number = addressData.number ? String(addressData.number).trim() : '';
    const complement = addressData.complement ? String(addressData.complement).trim() : '';
    const neighborhood = addressData.neighborhood ? String(addressData.neighborhood).trim() : '';
    const city = addressData.city ? String(addressData.city).trim() : '';
    const state = addressData.state ? String(addressData.state).trim() : '';
    const cep = addressData.cep ? String(addressData.cep).trim() : '';
    
    // Verificar se existem os campos obrigatórios
    if (!street || !number || !neighborhood || !city || !state) {
      return '';
    }
    
    // Construir o endereço formatado
    let formattedAddress = `${street}, ${number}`;
    
    if (complement) {
      formattedAddress += ` - ${complement}`;
    }
    
    formattedAddress += ` - ${neighborhood}, ${city} - ${state}`;
    
    if (cep) {
      formattedAddress += `, CEP ${cep}`;
    }
    
    return formattedAddress;
  } catch (error) {
    console.error('Erro ao formatar endereço:', error);
    return '';
  }
}; 